import _cloneDeep from 'lodash/cloneDeep';

/* @ngInject */
export default class ActivationFilterController {
    constructor($scope, currentFilters, onUpdate, onClose) {
        this.$scope = $scope;
        this.filters = _cloneDeep(currentFilters);
        this.onUpdate = onUpdate;
        this.onClose = onClose;
    }

    $onInit() {
        // Controller initialized with filters from parent
    }

    clear() {
        this.filters = { active: false, deactivated: false, replaced: false };
        this.apply();
    }

    apply() {
        this.onUpdate(this.filters);
        this.onClose();
    }
}
